
function LuhnAlgorithm(num){

    // var inputNum = num.toString();
    let sum = 0;
    let doubleUp = false;

    /* from the right to left, double every other digit starting with the second to last digit.*/
    for (let i = num.length - 1; i >= 0; i--)
    {
        let curDigit = parseInt(num.charAt(i));

        /* double every other digit starting with the second to last digit */
        if(doubleUp) {
            /* doubled number is greater than 9 than subtracted 9 */
            curDigit *= 2;
            if(curDigit > 9)
            {
              sum += curDigit - 9;
            }
            else
            {
              sum += curDigit;
            }
        }
        else
        {
          sum += curDigit;
        }
        doubleUp =!doubleUp
    }

  /* sum and divide it by 10. If the remainder equals zero, the original credit card number is valid.  */
  return (sum % 10) == 0  ? true : false;
};

function isSirenOrSiret(number){
    const la = LuhnAlgorithm(number);
    if (la)
    {
      if (number.length === 14)
      {
        const siren = number.substring(0, 9);
        return LuhnAlgorithm(siren);
      }
    }
    else
    {
      // siret = "35600053914285";  // test pour siret de la poste
      if (number.startsWith("356000")) // poste
      {
        let sum = 0;
        for (let i =  0; i < number.length; i++)
        {
            let c = number.charAt(i);
            let curDigit = parseInt(c);
            sum += curDigit;
        }
        return (sum % 5) == 0  ? true : false;
      }
    }
    return la;
}

export function isSiret(number) {
    if (!number) return false;
    if (!number.match(/^[0-9]{14}$/)) return false;
    return isSirenOrSiret(number);
}

export function isSiren(number) {
    if (!number) return false;
    if (!number.match(/^[0-9]{9}$/)) return false;
    return isSirenOrSiret(number);
}
